import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { device } from "../../utils/breakpoints";
import { Col, Container, Row } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import TrustpilotMiniWidget from "../../components/trustpilot/TrustpilotMiniWidget";
import useIsMobile from "../../components/hooks/useIsMobile";

const Tab = ({ title, description, defaultActiveState }) => {
  const [active, setActive] = useState(defaultActiveState);

  return (
    <StyledTab lg={12} onClick={() => setActive(!active)}>
      <div className={"d-flex justify-content-between"}>
        <h2>{title}</h2>
        {active ? <MinusOutlined /> : <PlusOutlined />}
      </div>
      <Description className={`content ${active && "active"}`}>
        {description}
      </Description>
    </StyledTab>
  );
};

const ProductInformationTab = ({
  additionalInfoTitle,
  additionalInfo,
  description,
  allergens,
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <div style={{ marginTop: "1.5rem" }}>
      <Container>
        <TabsContainer>
          {!!description && (
            <Tab
              title={t("description")}
              description={description}
              defaultActiveState={true}
            />
          )}
          {!!allergens && (
            <Tab
              title={t("allergens")}
              description={allergens.map((item) => `- ${item}\n`).join("")}
              defaultActiveState={false}
            />
          )}
          {!!additionalInfo && (
            <Tab
              title={additionalInfoTitle}
              description={additionalInfo}
              defaultActiveState={false}
            />
          )}
        </TabsContainer>
        {isMobile && (
          <TrustpilotMiniWidget style={{ marginTop: "1rem" }} scale={0.4} />
        )}
      </Container>
    </div>
  );
};

const StyledTab = styled(Col)`
  cursor: pointer;

  div h2 {
    font-size: 18px;
    color: #000;
    margin-bottom: 0.3rem;
    margin-right: 2rem;

    @media ${device.lg} {
      font-size: 22px;
    }
  }

  .anticon {
    font-size: 22px;
    @media ${device.lg} {
      font-size: 24px;
    }
  }

  & .content {
    transition: 0.35s ease-in-out;
    opacity: 0;
    max-height: 0;
    overflow: hidden;
    font-weight: 300;
    font-size: 18px;
    line-height: 1.2;
    margin-bottom: 1rem;

    &.active {
      opacity: 1;
      max-height: 2500px;
    }
  }
`;

const TabsContainer = styled(Row)``;

const Description = styled(ReactMarkdown)`
  p,
  li {
    font-size: 14px;
    font-weight: 300;
    line-height: 1.3;
    white-space: pre-line;

    @media only screen and ${device.lg} {
      font-size: 16px;
      line-height: 1.5;
    }
  }

  ul {
    //padding-inline-start: 0;
    list-style: inside;
    margin-block-start: 0;
    margin-block-end: 0;
    white-space: normal;
  }
`;
ProductInformationTab.propTypes = {
  additionalInfo: PropTypes.string,
  spaceBottomClass: PropTypes.string,
};

export default ProductInformationTab;
